import { useNavigate } from 'react-router-dom';
import { Ruler, Package, Database, Shirt } from 'lucide-react';
import UserHeader from '@/components/UserHeader';
import { useAuth } from '@/context/AuthContext';

const Home = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdmin = user?.role === 'Admin';

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <header className="text-center flex-1">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-3">
              FabricFlow
            </h1>
            <p className="text-base text-slate-500">Sample Stock Management System</p>
          </header>
          <UserHeader />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* TL Department */}
          <div
            onClick={() => navigate('/tl')}
            data-testid="tl-department-card"
            className="relative overflow-hidden rounded-3xl border-2 border-cyan-200 bg-gradient-to-br from-cyan-50 to-teal-50 transition-all hover:scale-[1.02] hover:shadow-xl cursor-pointer flex flex-col justify-center items-center text-center p-8 md:p-12 group min-h-[280px]"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-teal-600/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative z-10">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 rounded-full bg-cyan-600 flex items-center justify-center shadow-lg shadow-cyan-600/30">
                <Ruler className="w-10 h-10 md:w-12 md:h-12 text-white" />
              </div>
              <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-slate-800 mb-2">
                TL Department
              </h2>
              <p className="text-sm text-slate-600 mb-1">Yardages</p>
              <p className="font-mono text-xs text-cyan-700 font-semibold">Measured in Meters</p>
            </div>
          </div>

          {/* Swatches Department */}
          <div
            onClick={() => navigate('/swatches')}
            data-testid="swatches-department-card"
            className="relative overflow-hidden rounded-3xl border-2 border-indigo-200 bg-gradient-to-br from-indigo-50 to-violet-50 transition-all hover:scale-[1.02] hover:shadow-xl cursor-pointer flex flex-col justify-center items-center text-center p-8 md:p-12 group min-h-[280px]"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/10 to-violet-600/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative z-10">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 rounded-full bg-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-600/30">
                <Package className="w-10 h-10 md:w-12 md:h-12 text-white" />
              </div>
              <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-slate-800 mb-2">
                Swatches Department
              </h2>
              <p className="text-sm text-slate-600 mb-1">Fabric Samples</p>
              <p className="font-mono text-xs text-indigo-700 font-semibold">Measured in Pieces</p>
            </div>
          </div>

          {/* Garment Department */}
          <div
            onClick={() => navigate('/garments')}
            data-testid="garment-department-card"
            className="relative overflow-hidden rounded-3xl border-2 border-amber-200 bg-gradient-to-br from-amber-50 to-orange-50 transition-all hover:scale-[1.02] hover:shadow-xl cursor-pointer flex flex-col justify-center items-center text-center p-8 md:p-12 group min-h-[280px]"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-amber-500/10 to-orange-600/10 opacity-0 group-hover:opacity-100 transition-opacity"></div>
            <div className="relative z-10">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-4 md:mb-6 rounded-full bg-amber-600 flex items-center justify-center shadow-lg shadow-amber-600/30">
                <Shirt className="w-10 h-10 md:w-12 md:h-12 text-white" />
              </div>
              <h2 className="text-xl md:text-2xl font-semibold tracking-tight text-slate-800 mb-2">
                Garment Department
              </h2>
              <p className="text-sm text-slate-600 mb-1">Stitched Samples</p>
              <p className="font-mono text-xs text-amber-700 font-semibold">Measured in Pieces</p>
            </div>
          </div>
        </div>

        {/* Admin Backup Link */}
        {isAdmin && (
          <div className="mt-8 flex justify-center">
            <button
              onClick={() => navigate('/backup')}
              data-testid="backup-status-link"
              className="flex items-center gap-2 px-4 py-2 text-sm text-slate-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            >
              <Database className="w-4 h-4" />
              Backup Status
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;